var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-spinner"},[_c('no-ssr',{attrs:{"placeholder":"Loading.."}},[_c('b-spinner',{style:(_vm.style),attrs:{"label":"Loading","type":"grow","variant":"primary"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cab21e4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/misc/LoadingSpinner.vue
// module id = Vj/T
// module chunks = 0 103 104 105 106 107 108 109 110 111 113 114 118 119 120